import styled, { css } from 'styled-components';
import { getSVGSize, getIconButtonSize, getIconButtonBackgroundColorLoading, getIconButtonBackgroundColor, getBorderColor, getDisabledBackgroundColor, getHoverIconButtonBackground, getActiveIconButtonBackground, getSpinnerType, getIconButtonSvgColor } from './utils.js';
import { getDefaultTransition } from '../../utils/index.js';

const FlexButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
`;
styled(FlexButton) `
  ${({ size }) => getSVGSize(size)}
`;
const IconButtonContainer = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ size }) => getIconButtonSize(size)};
  width: ${({ size }) => getIconButtonSize(size)};
  border-radius: ${({ theme }) => theme.radius.roundedE};
  background-color: ${({ variant, isLoading, theme }) => {
    return isLoading
        ? getIconButtonBackgroundColorLoading(variant, theme.mode === 'dark')
        : getIconButtonBackgroundColor(variant);
}};
  border: 2px solid
    ${({ variant, hasFocus }) => getBorderColor(variant, hasFocus)};
  position: relative;
  top: -2px;
  right: 2px;
  ${({ disabled, variant, isLoading }) => {
    return (disabled &&
        !isLoading &&
        css `
        background-color: ${getDisabledBackgroundColor(variant)};
      `);
}}
  &:hover {
    cursor: ${({ isLoading }) => (isLoading ? 'wait' : 'pointer')};
    background: ${({ isLoading, disabled, variant, theme }) => !isLoading &&
    !disabled &&
    getHoverIconButtonBackground(variant, theme.mode === 'dark')};
  }
  &:active {
    background: ${({ isLoading, disabled, variant, theme }) => !isLoading &&
    !disabled &&
    getActiveIconButtonBackground(variant, theme.mode === 'dark')};
  }
  svg {
    ${({ size, variant, disabled, isLoading }) => {
    return css `
        ${getSVGSize(size)};
        fill: ${isLoading
        ? getSpinnerType(variant)
        : getIconButtonSvgColor(variant, disabled)};
      `;
}}
  }
  &:disabled:hover {
    cursor: not-allowed;
  }
  &:focus,
  &:focus-visible {
    outline: none;
  }
  ${getDefaultTransition()};
`;

export { FlexButton, IconButtonContainer };
